import { date } from 'quasar'

export default function (value: string | number) {
  const time = new Date(value)
  const today = date.startOfDate(new Date(), 'day')
  if (time > today) return date.formatDate(time , 'HH:mm')
  const week = date.subtractFromDate(today, { days: 7})
  if (time > week) return date.formatDate(time , 'dddd')
  const year = date.startOfDate(time, 'year')
  if (time > year) return date.formatDate(time , 'D MMM')
  return date.formatDate(time , 'D MMM \'YY')
}
